import React, { memo } from 'react'
import './GeneralCategoryItem.css'
import { CiShoppingTag } from 'react-icons/ci'
function GeneralCategoryItem({Styles,title,desc,icon}) {
  return (
    <>
     <div className='general-category-Item'>
      <div className='before-line' style={Styles}>
        
      </div>
      <div className='general-category-icon' style={Styles}>
        {icon}
      </div>
      <div className='general-category-title'>
        <div>
          <h1>{title}</h1>
        </div>
        <p>
             {desc}    
        </p>
      </div>
    </div>
    </>
   
  )
}

export default memo(GeneralCategoryItem)
